import { loadModules } from "esri-loader";
export default class ImageOverlays {
  private static intances: Map<string, ImageOverlays>;
  public view: __esri.MapView | __esri.SceneView;

  private scale: number = 8000;
  private imageCanvas: any;
  private allImages: any[] = [];
  private constructor(view: __esri.MapView | __esri.SceneView) {
    // Geometrical transformations that must be recomputed
    // from scratch at every frame.
    this.view = view;
    this.initialize();
  }

  public static getInstance(view: any) {
    let id = view.container.id;
    if (!ImageOverlays.intances) {
      ImageOverlays.intances = new Map();
    }
    let intance = ImageOverlays.intances.get(id);
    if (!intance) {
      intance = new ImageOverlays(view);
      ImageOverlays.intances.set(id, intance);
    }
    return intance;
  }

  public async addCanvasImage(params: any) {
    const [geometryJsonUtils] = await loadModules(["esri/geometry/support/jsonUtils"]);

    let point = params.geometry;
    if (!point.spatialReference) {
      point.spatialReference = this.view.spatialReference;
    }
    let geometry = geometryJsonUtils.fromJSON(point);
    let image = await this.loadImageAsync(params.url);

    let scale = params.scale || this.scale;

    let imageOverlay: any = params;
    imageOverlay.image = image; //图片
    imageOverlay.point = geometry; //坐标
    imageOverlay.scale = scale;
    let min = true;
    let max = true;
    if (params.minScale && params.minScale < scale) {
      min = false;
    }
    if (params.maxScale && params.maxScale > scale) {
      max = false;
    }
    if (min && max) {
      this.drawImage(imageOverlay);
    }
    this.allImages.push(imageOverlay);
  }

  private initialize() {
    let canvas = document.createElement("canvas");
    canvas.width = this.view.width;
    canvas.height = this.view.height;
    canvas.style.position = "absolute";
    canvas.style.left = "0px";
    canvas.style.top = "0px";
    this.imageCanvas = canvas;
    let parent = this.view.container.children[0].children[0];
    parent.insertBefore(canvas, parent.firstChild);
    this.addEvent();
  }

  private drawImage(imageOverlay: any) {
    let ctx: any = this.imageCanvas.getContext("2d");

    let step = imageOverlay.scale / this.view.scale;
    let width = imageOverlay.width * step * 1.25;
    let height = imageOverlay.height * step * 1.25;

    if (imageOverlay && imageOverlay.point) {
      let screenPoint = this.view.toScreen(imageOverlay.point);
      // console.log(screenPoint, imageOverlay.point);
      if (screenPoint) {
        ctx.drawImage(imageOverlay.image, screenPoint.x - width / 2, screenPoint.y - height / 2, width, height);
      }
    }
  }

  //清除画布canvas
  public clearCanvas() {
    let ctx: any = this.imageCanvas.getContext("2d");
    ctx.clearRect(0, 0, this.imageCanvas.width, this.imageCanvas.height);
  }

  private addEvent() {
    let o: any = this;

    o.view.watch("extent", (event: any) => {
      let scale = o.view.scale;
      let images = o.allImages;
      o.clearCanvas();
      for (let image of images) {
        if (image.visible !== false) {
          let min = true;
          let max = true;
          if (image.minScale && image.minScale < scale) {
            min = false;
          }
          if (image.maxScale && image.maxScale > scale) {
            max = false;
          }
          if (min && max) {
            o.drawImage(image);
          }
        }
      }
    });
  }

  private async loadImageAsync(url: string) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = url;
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        resolve(image);
      };
      image.onerror = function () {
        reject(0);
      };
    });
  }
}
